import React from "react";
import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";
import PreconfiguredLog from "./PreconfiguredLog";
import Log from "./Log";
import HvmLog from "./HvmLog";
import SvmLog from "./SvmLog";
import WiseLog from "./WiseLog";
import ManualLog from "./ManualLog";

import Option_Startlab from "./Actions/Runninglabs_Startlab";
import Option_Stoplab from "./Actions/Runninglabs_Stoplab";

// import Start from "./Start";
// import PreconfiguredStart from "./PreconfiguredStart";
// import HvmStart from "./HvmStart";
// import SvmStart from "./SvmStart";
// import WiseStart from "./WiseStartlab";
// import ManualStart from "./ManualStartLab";

// import Stop from "./Stop";
// import PreconfiguredStop from "./PreconfiguredStop";
// import HvmStop from "./HvmStop";
// import SvmStop from "./SvmStop";
// import WiseStop from "./WiseStoplab";
// import ManualStop from "./ManualStopLab";
import SupportTeam from "./SupportTeam";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export default function SimpleMenu(props) {
  const { InstanceID, name, status, spent, budget, type, billingtype, endDate, endTime, startDate, startTime, depends_on, manage_labs, startcron1, startcron2, repeat_frequency, on_days } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>

      {type === "preconfig" ? (
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
            <PreconfiguredLog InstanceID={InstanceID} />
          {status === "Failed" ||
          status === "Cordoned" ||
          status === "Creating" ||
          status === "Running" ||
          status === "Retrying" ||
          status === "Stopping" ? (
            ""
          ) : (
              // <PreconfiguredStart
              //   InstanceID={InstanceID}
              //   status={status}
              //   spent={spent}
              //   budget={budget}
              //   billingtype={billingtype}
              // />
              <Option_Startlab
                InstanceID={InstanceID}
                status={status}
                spent={spent}
                budget={budget}
                endDate={endDate}
                endTime={endTime}
                startDate={startDate}
                startTime={startTime}
                depends_on={depends_on}
                manage_labs={manage_labs}
                startcron={startcron1}
                startcron1={startcron2}
                repeat_frequency={repeat_frequency}
                on_days={on_days}
                labType="preconfig"
              />
          )}
          {status === "Failed" ||
          status === "Cordoned" ||
          status === "Creating" ||
          status === "Stopped" ||
          status === "Retrying" ||
          status === "Stopping" ? (
            ""
          ) : (
              // <PreconfiguredStop InstanceID={InstanceID} status={status} />
            <Option_Stoplab
              InstanceID={InstanceID}
              status={status}
              endDate={endDate}
              endTime={endTime}
              startDate={startDate}
              startTime={startTime}
              depends_on={depends_on}
              manage_labs={manage_labs}
              labType="preconfig"
            />
          )}
            <SupportTeam status={status} />
        </Menu>
      ) : type === "custom" ? (
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <Log InstanceID={InstanceID} />
          {status === "Failed" ||
          status === "Cordoned" ||
          status === "Creating" ||
          status === "Running" ||
          status === "Retrying" ||
          status === "Stopping" ? (
            ""
          ) : (
              <Option_Startlab
                InstanceID={InstanceID}
                status={status}
                spent={spent}
                budget={budget}
                endDate={endDate}
                endTime={endTime}
                startDate={startDate}
                startTime={startTime}
                depends_on={depends_on}
                manage_labs={manage_labs}
                startcron={startcron1}
                startcron1={startcron2}
                repeat_frequency={repeat_frequency}
                on_days={on_days}
                labType="custom"
              />
          )}
          {status === "Failed" ||
          status === "Cordoned" ||
          status === "Creating" ||
          status === "Stopped" ||
          status === "Retrying" ||
          status === "Stopping" ? (
            ""
          ) : (
              // <Stop InstanceID={InstanceID} status={status} />
              <Option_Stoplab
                InstanceID={InstanceID}
                status={status}
                endDate={endDate}
                endTime={endTime}
                startDate={startDate}
                startTime={startTime}
                depends_on={depends_on}
                manage_labs={manage_labs}
                labType="custom"
              />
          )}
            <SupportTeam status={status} />
        </Menu>
      ) : type === "hvm" ? (
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
            <HvmLog InstanceID={InstanceID} />
          {status === "Failed" ||
          status === "Cordoned" ||
          status === "Creating" ||
          status === "Running" ||
          status === "Retrying" ||
          status === "Stopping" ? (
            ""
          ) : (
              // <HvmStart
              //   InstanceID={InstanceID}
              //   status={status}
              //   spent={spent}
              //   budget={budget}
              // />
              <Option_Startlab
                InstanceID={InstanceID}
                status={status}
                spent={spent}
                budget={budget}
                endDate={endDate}
                endTime={endTime}
                startDate={startDate}
                startTime={startTime}
                depends_on={depends_on}
                manage_labs={manage_labs}
                startcron={startcron1}
                startcron1={startcron2}
                repeat_frequency={repeat_frequency}
                on_days={on_days}
                labType="hvm"
              />
          )}
          {status === "Failed" ||
          status === "Cordoned" ||
          status === "Creating" ||
          status === "Stopped" ||
          status === "Retrying" ||
          status === "Stopping" ? (
            ""
          ) : (
              // <HvmStop InstanceID={InstanceID} status={status} />
            <Option_Stoplab
              InstanceID={InstanceID}
              status={status}
              endDate={endDate}
              endTime={endTime}
              startDate={startDate}
              startTime={startTime}
              depends_on={depends_on}
              manage_labs={manage_labs}
              labType="hvm"
            />
          )}
            <SupportTeam status={status} />
        </Menu>
      ) : type === "sharedvm" ? (
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
            <SvmLog InstanceID={InstanceID} />
          {status === "Failed" ||
          status === "Cordoned" ||
          status === "Creating" ||
          status === "Running" ||
          status === "Retrying" ||
          status === "Stopping" ? (
            ""
          ) : (
              // <SvmStart
              //   InstanceID={InstanceID}
              //   status={status}
              //   spent={spent}
              //   budget={budget}
              // />
              <Option_Startlab
                InstanceID={InstanceID}
                status={status}
                spent={spent}
                budget={budget}
                endDate={endDate}
                endTime={endTime}
                startDate={startDate}
                startTime={startTime}
                depends_on={depends_on}
                manage_labs={manage_labs}
                startcron={startcron1}
                startcron1={startcron2}
                repeat_frequency={repeat_frequency}
                on_days={on_days}
                labType="svm"
              />
          )}
          {status === "Failed" ||
          status === "Cordoned" ||
          status === "Creating" ||
          status === "Stopped" ||
          status === "Retrying" ||
          status === "Stopping" ? (
            ""
          ) : (
              // <SvmStop InstanceID={InstanceID} status={status} />
            <Option_Stoplab
              InstanceID={InstanceID}
              status={status}
              endDate={endDate}
              endTime={endTime}
              startDate={startDate}
              startTime={startTime}
              depends_on={depends_on}
              manage_labs={manage_labs}
              labType="svm"
            />
          )}
            <SupportTeam status={status} />
        </Menu>
      ) : type === "wise" ? (
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
            <WiseLog InstanceID={InstanceID} />
          {status === "Failed" ||
          status === "Cordoned" ||
          status === "Creating" ||
          status === "Running" ||
          status === "Retrying" ||
          status === "Stopping" ? (
            ""
          ) : (
              // <WiseStart
              //   InstanceID={InstanceID}
              //   status={status}
              //   spent={spent}
              //   budget={budget}
              // />
              <Option_Startlab
                InstanceID={InstanceID}
                status={status}
                spent={spent}
                budget={budget}
                endDate={endDate}
                endTime={endTime}
                startDate={startDate}
                startTime={startTime}
                depends_on={depends_on}
                manage_labs={manage_labs}
                startcron={startcron1}
                startcron1={startcron2}
                repeat_frequency={repeat_frequency}
                on_days={on_days}
                labType="wise"
              />
          )}
          {status === "Failed" ||
          status === "Cordoned" ||
          status === "Creating" ||
          status === "Stopped" ||
          status === "Retrying" ||
          status === "Stopping" ? (
            ""
          ) : (
              // <WiseStop InstanceID={InstanceID} status={status} />
            <Option_Stoplab
              InstanceID={InstanceID}
              status={status}
              endDate={endDate}
              endTime={endTime}
              startDate={startDate}
              startTime={startTime}
              depends_on={depends_on}
              manage_labs={manage_labs}
              labType="wise"
            />
          )}
            <SupportTeam status={status} />
        </Menu>
      ) : type === "manual" ? (
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
            <ManualLog InstanceID={InstanceID} />
          {status === "Failed" ||
          status === "Cordoned" ||
          status === "Creating" ||
          status === "Running" ||
          status === "Retrying" ||
          status === "Stopping" ? (
            ""
          ) : (
              // <ManualStart
              //   InstanceID={InstanceID}
              //   status={status}
              //   spent={spent}
              //   budget={budget}
              // />
            <Option_Startlab
              InstanceID={InstanceID}
              status={status}
              spent={spent}
              budget={budget}
              endDate={endDate}
              endTime={endTime}
              startDate={startDate}
              startTime={startTime}
              depends_on={depends_on}
              manage_labs={manage_labs}
              startcron={startcron1}
              startcron1={startcron2}
              repeat_frequency={repeat_frequency}
              on_days={on_days}
              labType="manual"
            />
          )}
          {status === "Failed" ||
          status === "Cordoned" ||
          status === "Creating" ||
          status === "Stopped" ||
          status === "Retrying" ||
          status === "Stopping" ? (
            ""
          ) : (
              // <ManualStop InstanceID={InstanceID} status={status} />
            <Option_Stoplab
              InstanceID={InstanceID}
              status={status}
              endDate={endDate}
              endTime={endTime}
              startDate={startDate}
              startTime={startTime}
              depends_on={depends_on}
              manage_labs={manage_labs}
              labType="manual"
            />
          )}
            <SupportTeam status={status} />
        </Menu>
      ) : (
        ""
      )}
    </div>
  );
}
